import React from 'react';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { Link } from '@framework/router/Next/Link';
import { getDealRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import {
  getBondName,
  getFormattedBond,
} from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/heplers';
import { IPosition } from '@/creditflowresearch/domain/vo/PortfolioMonitor/ICreatePortfolioFormState';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';

import cellStyles from '@/creditflowresearch/ui/common/components/TableCells/styles.module.scss';

interface IProps {
  row: IPosition,
}

const BondNameCell = (props: IProps) => {
  const { row } = props;
  const bond = row?.bond;

  if (bond?.customBondName) {
    return (
      <Tooltip content={ bond.customBondName }>
        <span className={ cellStyles.nameCell }>{ bond.customBondName }</span>
      </Tooltip>
    );
  }

  if (bond?.dealId) {
    const formattedBond = getFormattedBond(bond);
    const dealRoute = getDealRoute(formattedBond as unknown as Partial<IDeal>);
    return (
      <Link to={ dealRoute } target="_blank" dataTest="bondName">
        { getBondName(bond) }
      </Link>
    );
  }

  return bond?.label || '-';
};

export default BondNameCell;
